import { render, staticRenderFns } from "./Categoryads.vue?vue&type=template&id=15184be4"
import script from "./Categoryads.vue?vue&type=script&lang=js"
export * from "./Categoryads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports